import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { iConsumptionKind } from "src/model/interface/iConsumptionKind";

import { AlertService } from "src/service/alert.service";
import { DpBillsService } from "src/service/bills.service";
import { Resident } from "src/model/class/general classes/resident";

import { User } from "src/model/class/general classes/user";
import { UsersRole } from "src/model/enum/enumDigitalPlace";

@Component({
    selector: "app-form-residents",
    templateUrl: "./form-residents.component.html",
    styleUrls: ["./form-residents.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormResidentsComponent implements OnInit {
  public fileSelected: File = null;
  public formResident: UntypedFormGroup = null;
  public arrayConsumptionKind: Array<iConsumptionKind> = [];
  public showErrorMessageOnClick: boolean = false;
  public isFileContentChanged = false;
  public isAdministrator: UsersRole;
  public isEmailValorized: boolean = false;
  public isTaxcodeValorized: boolean = false;

  @Input() okText: string;
  @Input() closeText: string;
  @Input() resident: Resident;
  @Input() deleteFileConfirmationMsg: string;
  @Input() role: UsersRole;

  constructor(private _fb: UntypedFormBuilder, private _alertService: AlertService) {}

  ngOnInit() {
    this.initializeResidentForm();
    this.isAdministrator = UsersRole.BUILDING_ADMINISTRATOR;
  }

  public createDataForm() {
    const createdResident: Resident = this.formResident.getRawValue();
    return createdResident;
  }

  /**
   * Initialize form
   */
  private initializeResidentForm(): void {
    if (this.resident?.email) {
      this.isEmailValorized = true;
    }
    if (this.resident?.taxCode) {
      this.isTaxcodeValorized = true;
    }
    this.formResident = this._fb.group({
      name: [
        this.resident ? this.resident.name : "",
        {
          validators: [Validators.required],
        },
      ],
      surname: [
        this.resident ? this.resident.surname : "",
        {
          validators: [Validators.required],
        },
      ],
      taxCode: [
        { value: this.resident ? this.resident.taxCode : "", disabled: this.isTaxcodeValorized },
        Validators.required,
      ],
      email: [
        { value: this.resident ? this.resident.email : "", disabled: this.isEmailValorized }
      ],
      administrator: [""],
    });

    
  }
}
